<template>
  <div>
    <el-dialog :title="form.id ? '修改': '新增'" :append-to-body="true" :visible.sync="addDialogVisible" class="imgbox" width="30%" :before-close="closeDialog" :close-on-click-modal='false'>
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form">

        <el-form-item label="厂商名称" prop="vendorName">
          <el-input v-model="form.vendorName" maxlength="30" placeholder="请输入厂商名称"></el-input>
        </el-form-item>

        <el-form-item label="厂商Id" prop="vendorId">
          <el-input :disabled="form.id" v-model="form.vendorId" maxlength="50" placeholder="请输入厂商名称"></el-input>
        </el-form-item> 

        <el-form-item label="描述信息" prop="vendorDesc">
          <el-input v-model="form.vendorDesc" maxlength="50" placeholder="请输入描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { vendorUpdate, vendorAdd, vendorGet } from '@/api/productControl'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    vendorUpdateId: { 
      type: String
    }
  },
  data () {
    return {
      form: {
        vendorId: '',
        vendorName: '',
        vendorDesc: ''
      },
      rules: {
        vendorName: [
          { required: true, message: '请输入厂商名称', trigger: 'change' }
        ],
        vendorId: [
          { required: true, message: '请输入厂商Id', trigger: 'change' }
        ],
        vendorDesc: [
          { required: false, message: '请输入厂商描述', trigger: 'change' }
        ],
      }
    }
  },
  created() {
    if (this.vendorUpdateId) {
      this.getVendorById()
    }
  },
  methods: {
    getVendorById() {
      let params = {
        id: this.vendorUpdateId
      }
      vendorGet(params).then(res => {
        this.form = res.data.data;
      })
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.form.id) {
            const params = Object.assign({}, this.form)
            vendorAdd(params).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          } else {
            const params = Object.assign({}, this.form)
            vendorUpdate(params).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          }
        }
      })
    },
    closeDialog () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>